module.exports = __webpack_public_path__ + "static/header-638279b6615473c55c649db31000f8dd.png";